import React from "react";
//styles
import { SignupStepWrapper } from "./styles";

//elements
import { Title, Text } from "../../../../elements/Typography";
import { Button, StyledLink } from "../../../../elements/CTA";
import { Input } from "../../../../elements/Input";
import Stepper from "../../../../elements/Stepper";

//assets
import LogoDefault from "../../../../assets/img/logo-ola-colorido.svg";

const EmailConfirmation = ({
  handleAction,
  handleInputChange,
  globalState
}) => (
  <SignupStepWrapper className="email-confirmation">
    <div style={{ width: "100%", textAlign: "center" }}>
      <img src={LogoDefault} className="auth-logo" alt="logo ola" />
    </div>
    <Stepper>
      <div className="stepper">
        <section className="step-indicator">
          <div className="step step1 active">
            <button
              type="submit"
              onClick={e => handleAction(e, "begin")}
              className="step-icon"
            >
              <span />
            </button>
          </div>
          <div className="indicator-line active" />
          <div className="step step2">
            <button
              type="submit"
              onClick={e => handleAction(e, "password")}
              className="step-icon"
            >
              <span />
            </button>
          </div>
          <div className="indicator-line" />
          <div className="step step3">
            <button
              type="submit"
              onClick={e => handleAction(e, "register")}
              className="step-icon"
            >
              <span />
            </button>
          </div>
        </section>
      </div>
    </Stepper>
    <Title size="1" content="Confirme seu e-mail" typeClass="auth-title" />
    <Text
      typeClass="auth-subtitle"
      content="Verifique a caixa do email johnsnow@olapodcasts.com.br
      e para confirmar sua conta, digite o código abaixo:"
    />
    <div>
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
      <Input
        placeholder=""
        border="none"
        background="#FFF"
        inputClasses="confirmation-input"
        borderBottom="3px solid #4A4A49"
        color="var(--color-first)"
      />
    </div>

    <Button
      type="button"
      className="auth-button"
      Background="var(--color-first)"
      Color="var(--color-zero)"
      onClick={e => handleAction(e, "register")}
    >
      Criar uma Conta
    </Button>

    <div className="auth-login">
      <Text type="span" content="Não recebi o codigo" />
      <StyledLink
        type="submit"
        to="/signin"
        className="login-button"
        Color="var(--color-first)"
      >
        Reenviar
      </StyledLink>
    </div>
  </SignupStepWrapper>
);

export default EmailConfirmation;
